<app-top-banner></app-top-banner>
<section class="yoga appointments format bg img-1" id="services" style="background: url(assets/images/yoga-img/physio-wallpapers/6.jpg) no-repeat 50% 50px fixed; background-size: cover !important">
  <app-back-arrow></app-back-arrow>
  <div class="container">
      <div class="row">
          <div class="col-md-8 offset-md-2" style="margin-bottom: 50px;">
              <div class="title title2">
                  <h2 class="">Appointments</h2>
                  <!-- <img src="assets/images/yoga-img/logo/wave-blue.png" alt="" class="img-fluid"> -->
              </div>
          </div>
          <div class="col-md-12 experience-container" >
              <div class="center-text">
                  <div class="w-100">
                    <div class="row">
                      <div class="col-md-8 offset-md-2 ">
                        <h3 class="sub-heading">
                          Opening times
                        </h3>
                        <div class="row">
                          <div class="col-md-12">
                            <h5>
                              Table View Physiotherapy Practice Hours:
                            </h5>

                            <p>
                              Monday-Friday 8am-5pm
                            </p>
                            <p>
                              Saturday 9am-1pm
                            </p>
                          </div>

                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <h5>
                              Milnerton Physiotherapy Practice Hours:
                            </h5>
                            <p>
                              Monday-Friday 8am-5pm
                            </p>
                            <h5>
                              Practice No: 0496758
                            </h5>
                          </div>

                        </div>

                      </div>

                    </div>
                    <div class="row">
                      <div class="col-md-8 offset-md-2">
                        <h3 class="sub-heading">Bookings and fees policy</h3>
                        <h6 style="margin-top: 10px;">
                          Appointments can be made by calling us or by visiting one of our practices. Physiotherapists are first-line practitioners; doctor's referral is not necessary.
                        </h6>

                        <div class="row">
                          <div class="col-md-12">
                            <h5>
                              What to expect at 1st Appointment
                            </h5>

                            <p>
                              The initial appointment is used to complete a thorough assessment, identify a diagnosis, and establish an appropriate treatment plan for your condition. You may be expected to undress so that the physiotherapist is able to examine the relevant area, so comfortable clothing is advised. We do have shorts available if necessary.
                            </p>
                          </div>

                        </div>


                        <div class="row">
                          <div class="col-md-12">
                            <h5>
                              Fees:
                            </h5>

                            <p>
                              Fees are guided by the tariffs advised to us by the various Medical Aid Funds. ICD-10 codes are utilised with invoices submitted directly to your medical fund. There may, however, be a small discrepancy due to the lack of a standardised price list. The member will be responsible for any difference. Patients who are not members of a medical aid fund, or without medical aid funds available for physiotherapy, will be expected to settle their accounts after each consultation. Credit card facilities are available. We regret that we are not able to accept Diners Club or American Express cards.
                            </p>

                            <p>
                              Please note that we are a VAT Registered Physiotherapy Practice.
                            </p>
                          </div>

                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <h5>
                              Cancellation Policy:
                            </h5>

                            <p>
                              Appointments not cancelled 2 hours prior to the scheduled time will be charged at R440 per half-hour for your private account.
                            </p>
                          </div>

                        </div>


                      </div>

                    </div>
                  </div>
              </div>
          </div>

      </div>
  </div>
</section>

<app-footer [displayScrollToTop]="false"></app-footer>
